import React from 'react';
import styled from 'styled-components';

import { extractAllocationStatistics } from '../utils';
import messages from './messages';

import { FormattedNumber, FormattedMessage } from 'react-intl';
import getSymbolFromCurrency from 'currency-symbol-map';

const StatsContainer = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    background-color: #fbfbfb;
    box-shadow: 0 2px 4px 0 rgba(215, 215, 215, 0.5);
    padding: 15px;

    & > div {
        flex: 1;
    }
`;

const StatItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    & > div:first-child {
        font-weight: bold;
        text-align: center;
    }
`;

const StatisticsHeader = (props) => {
    const { currency } = props;
    const { blockedRoomCount, availableRoomCount, revenueSold, roomsSold, estimatedRevenueTotal } =
        extractAllocationStatistics(props);

    const currencySymbol = getSymbolFromCurrency(currency);
    return (
        <StatsContainer>
            <StatItem>
                <FormattedMessage tagName="div" {...messages.blockedRoomCountLabel} />
                <div>
                    <FormattedNumber value={blockedRoomCount} />
                </div>
            </StatItem>
            <StatItem>
                <FormattedMessage tagName="div" {...messages.pickedUpRoomCountLabel} />
                <div>
                    <FormattedNumber value={roomsSold} />
                </div>
            </StatItem>
            <StatItem>
                <FormattedMessage tagName="div" {...messages.availableRoomCountLabel} />
                <div>
                    <FormattedNumber value={availableRoomCount} />
                </div>
            </StatItem>
            <StatItem>
                <FormattedMessage tagName="div" {...messages.revenueSoldLabel} />
                <div>
                    {currencySymbol}
                    <FormattedNumber value={revenueSold / 100} minimumFractionDigits={0} maximumFractionDigits={0} />
                </div>
            </StatItem>
            <StatItem>
                <FormattedMessage tagName="div" {...messages.estimatedRevenueTotalLabel} />
                <div>
                    {currencySymbol}
                    <FormattedNumber
                        value={estimatedRevenueTotal / 100}
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                    />
                </div>
            </StatItem>
        </StatsContainer>
    );
};

export default StatisticsHeader;
